import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156d7b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body'}",
  style: {"z-index":"100 !important"}
}
const _hoisted_2 = {
  class: "menu menu-column menu-state-bg menu-title-gray-700 menu-state-title-secundary menu-state-icon-secundary menu-state-bullet-secundary menu-arrow-gray-400 fw-bold my-5 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "menu-title" }
const _hoisted_6 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-accordion"
}
const _hoisted_7 = { class: "menu-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_9 = { class: "menu-sub menu-sub-accordion menu-rounded-0" }
const _hoisted_10 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-accordion"
}
const _hoisted_11 = { class: "menu-icon" }
const _hoisted_12 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_13 = { class: "menu-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_15 = { class: "menu-sub menu-sub-accordion menu-active-bg" }
const _hoisted_16 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-accordion"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_18 = { class: "menu-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_20 = { class: "menu-sub menu-sub-accordion menu-active-bg" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_25 = { class: "menu-title" }
const _hoisted_26 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "menu-icon" }
const _hoisted_29 = { class: "svg-icon svg-icon-2" }
const _hoisted_30 = { class: "menu-title" }
const _hoisted_31 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu--accordion"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-link py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Relatórios"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1))
const _hoisted_33 = {
  class: "menu-sub menu-sub-accordion w-100 p-5",
  style: {}
}
const _hoisted_34 = {
  class: "row",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "menu-section fs-5 fw-bolder ps-1 py-1" }, "Gerenciais")
    ])
  ])
], -1))
const _hoisted_38 = { class: "menu-item" }
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Fechamento Mensal ", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "menu-item" }
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Histórico Mensal ", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "menu-item" }
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Fechamento Mensal com Análises IA ", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "menu-item" }
const _hoisted_54 = ["href"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Exportar Dados por Grupo ", -1))
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "menu-item" }
const _hoisted_59 = ["href"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Exportar Itens em Foco ", -1))
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "menu-section fs-5 fw-bolder ps-1 py-1" }, "Atividades")
    ])
  ])
], -1))
const _hoisted_66 = { class: "menu-item" }
const _hoisted_67 = ["href"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Log de Acessos ", -1))
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = { class: "menu-item" }
const _hoisted_72 = ["href"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Log de Acessos App ", -1))
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = { class: "menu-item" }
const _hoisted_77 = ["href"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Log Detalhado ", -1))
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { class: "menu-item" }
const _hoisted_82 = ["href"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Arquivos Exportados ", -1))
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_87 = ["href"]
const _hoisted_88 = { class: "menu-title" }
const _hoisted_89 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-accordion"
}
const _hoisted_90 = { class: "menu-title" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_92 = { class: "menu-sub menu-sub-accordion menu-rounded-0" }
const _hoisted_93 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-accordion"
}
const _hoisted_94 = { class: "menu-title" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_96 = { class: "menu-sub menu-sub-accordion menu-active-bg" }
const _hoisted_97 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-accordion"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_99 = { class: "menu-title" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_101 = { class: "menu-sub menu-sub-accordion menu-active-bg" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_103 = { class: "menu-title" }
const _hoisted_104 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_106 = { class: "menu-title" }
const _hoisted_107 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_108 = ["href"]
const _hoisted_109 = { class: "menu-title" }
const _hoisted_110 = { class: "d-flex flex-grow-1 flex-column justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UserMenu = _resolveComponent("UserMenu")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UserMenu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuHeaders, (item, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("template", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (menuItem, j) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                    (menuItem.sectionTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_router_link, {
                            to: menuItem.route
                          }, {
                            default: _withCtx(({ isExactActive }) => [
                              _createElementVNode("a", {
                                href: menuItem.route,
                                class: _normalizeClass(["menu-link py-3", [isExactActive && 'active']])
                              }, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(menuItem.sectionTitle), 1)
                              ], 10, _hoisted_4)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }])
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.sectionTitle), 1),
                  _hoisted_8
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (menuItem, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }])
                            }, [
                              _createElementVNode("span", _hoisted_11, [
                                (_ctx.headerMenuIcons === 'font')
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass([menuItem.fontIcon, "fas fs-3"])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (_ctx.headerMenuIcons === 'svg')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _createVNode(_component_inline_svg, {
                                        src: menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_13, "a" + _toDisplayString(menuItem.sectionTitle) + "a", 1),
                              _hoisted_14
                            ], 2),
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["menu-link py-3", {
                            active: _ctx.hasActiveChildren(menuItem1.route),
                          }])
                                        }, [
                                          _hoisted_17,
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_19
                                        ], 2),
                                        _createElementVNode("div", _hoisted_20, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_21,
                                                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link py-3",
                                          to: menuItem1.route
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_24,
                                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("a", {
                              class: "menu-link py-3",
                              href: menuItem.route
                            }, [
                              _createElementVNode("span", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, [
                                  _createVNode(_component_inline_svg, {
                                    src: 
                            menuItem.svgIcon
                              ? menuItem.svgIcon
                              : 'media/icons/duotune/layouts/lay009.svg'
                          
                                  }, null, 8, ["src"])
                                ])
                              ]),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(menuItem.heading), 1)
                            ], 8, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("template", null, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("a", {
                          href: '/controlelancamentos.php',
                          class: "menu-link"
                        }, _hoisted_42, 8, _hoisted_39)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("a", {
                          href: '/dashboard_concessionarias.php',
                          class: "menu-link"
                        }, _hoisted_47, 8, _hoisted_44)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("a", {
                          href: '/dashboard_relatorio_ia.php',
                          class: "menu-link"
                        }, _hoisted_52, 8, _hoisted_49)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("a", {
                          href: '/filtroexportardadosgrupo.php',
                          class: "menu-link"
                        }, _hoisted_57, 8, _hoisted_54)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("a", {
                        href: '/filtroexportaritensemfoco.php',
                        class: "menu-link"
                      }, _hoisted_62, 8, _hoisted_59)
                    ])
                  ])
                ]),
                _createElementVNode("template", null, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _hoisted_65,
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("a", {
                          href: '/listaacessos.php',
                          class: "menu-link"
                        }, _hoisted_70, 8, _hoisted_67)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("a", {
                          href: '/logacessoslistapp.php',
                          class: "menu-link"
                        }, _hoisted_75, 8, _hoisted_72)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("a", {
                          href: '/log_acessoslist.php',
                          class: "menu-link"
                        }, _hoisted_80, 8, _hoisted_77)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("a", {
                          href: '/concessionariasarqexportlist.php',
                          class: "menu-link"
                        }, _hoisted_85, 8, _hoisted_82)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuHeadersWithoutIcon, (item, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("template", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (menuItem, j) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                    (menuItem.sectionTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createVNode(_component_router_link, {
                            to: menuItem.route
                          }, {
                            default: _withCtx(({ isExactActive }) => [
                              _createElementVNode("a", {
                                href: menuItem.route,
                                class: _normalizeClass(["menu-link py-3", [isExactActive && 'active']])
                              }, [
                                _createElementVNode("span", _hoisted_88, _toDisplayString(menuItem.sectionTitle), 1)
                              ], 10, _hoisted_87)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("span", {
                  class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }])
                }, [
                  _createElementVNode("span", _hoisted_90, _toDisplayString(item.sectionTitle), 1),
                  _hoisted_91
                ], 2),
                _createElementVNode("div", _hoisted_92, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (menuItem, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }])
                            }, [
                              _createElementVNode("span", _hoisted_94, "a" + _toDisplayString(menuItem.sectionTitle) + "a", 1),
                              _hoisted_95
                            ], 2),
                            _createElementVNode("div", _hoisted_96, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["menu-link py-3", {
                            active: _ctx.hasActiveChildren(menuItem1.route),
                          }])
                                        }, [
                                          _hoisted_98,
                                          _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_100
                                        ], 2),
                                        _createElementVNode("div", _hoisted_101, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_102,
                                                  _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link py-3",
                                          to: menuItem1.route
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_105,
                                            _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            _createElementVNode("a", {
                              class: "menu-link py-3",
                              href: menuItem.route
                            }, [
                              _createElementVNode("span", _hoisted_109, _toDisplayString(menuItem.heading), 1)
                            ], 8, _hoisted_108)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ], 64))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_110, [
        _createVNode(_component_el_tooltip, {
          class: "item",
          effect: "dark",
          content: "Clique para realizar possíveis atualizações",
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "pointer versao-app",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh()))
            }, _toDisplayString(_ctx.appVersion), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}